export default __webpack_public_path__ + "static/media/Kanha-National-Park.b0cb9b94.jpg";